import type { ViewportToolsetPlugin } from "@/viewport-tools/plugin-types";
import type { ScaleToolsetRailController } from "@/viewport-tools/rail/types";
import { getScaleToolDefinitions, SCALE_TOOLSET } from "./registry";
import { SCALE_TOOLSET_RAIL_PLUGIN } from "./rail-plugin";

export const SCALE_VIEWPORT_TOOLSET_PLUGIN: ViewportToolsetPlugin<ScaleToolsetRailController> =
  {
  id: SCALE_TOOLSET.id,
  toolset: SCALE_TOOLSET,
  getTools: () => getScaleToolDefinitions(),
  rail: SCALE_TOOLSET_RAIL_PLUGIN,
  };
